import { convertDateFilterValueToDate, getStartAndEndDateForQuickOption } from "utils/dateUtils";
import GlobalSettingAPI from "./GlobalSettingAPI";
import {  makeCancellableAPIRequest } from "./index";
import moment from "moment";
import { cloneDeep } from "lodash";

const ExceptionAPI = {
    getExceptions(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/risk-register/filter",
            {
                data: modifyFilters(data)
            }
        )
    },
    get(id) {
        return makeCancellableAPIRequest(
            "GET",
            `/api/risk-register/${id}`,
        )
    },
    saveException(data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/risk-register`,
             {
                data
            }
        )
    },
    deleteException(id){
      return makeCancellableAPIRequest(
        "DELETE",
        `/api/risk-register/${id}`
      )
    },
    exceptionReport(id){
      return makeCancellableAPIRequest(
        "GET",
        `api/risk-register/${id}/report`
      )
    },
    getApprovers() {
        return makeCancellableAPIRequest(
            "GET",
            '/api/risk-register/available-reviewers'
        )
    },
    update(id, data) {
        return makeCancellableAPIRequest("PUT", `/api/risk-register/${id}`, {
          data,
        });
    },
    validate(params, showDefaultMessage = true){
      return makeCancellableAPIRequest(
        "GET",
        "/api/risk-register/validate",
        {
          params
        },
        showDefaultMessage
      )
    },
    getApprovalHistory(id) {
        return makeCancellableAPIRequest(
            "GET",
            `/api/risk-register/${id}/history/approvals`,
        )
    },
    getDocuments(id) {
        return makeCancellableAPIRequest(
            "GET",
            `/api/risk-register/${id}/documents`,
        )
    },
    getDocumentSignedUrl(id, params) {
        return makeCancellableAPIRequest(
          "POST",
          `/api/risk-register/${id}/documents/upload-url`,
          { params }
        );
    },
    deleteDocument(exceptionId, documentId) {
        return makeCancellableAPIRequest(
          "DELETE",
          `/api/risk-register/${exceptionId}/documents/${documentId}`
        );
    },
    triggerArchive(exceptionId) {
        return makeCancellableAPIRequest(
          "POST",
          `/api/risk-register/${exceptionId}/archive`
        );
    },
    triggerSubmit(data, id, sendData = false) {
      return sendData ? 
        makeCancellableAPIRequest(
          "POST",
          `/api/risk-register/${id}/submit`,
          {
            data
          }
        ) : 
         makeCancellableAPIRequest(
          "POST",
          `/api/risk-register/${id}/submit`,
        ) 
        ;
    },
    getFilterExceptions(params) {
        return makeCancellableAPIRequest(
            "GET",
            "/api/risk-register/filters-options",
            {
              params
            }
        )
    },
    getReasons() {
        const request = GlobalSettingAPI.getExceptionConfig();
        request.promise = request.promise.then(r => r.reasons);
        return request;
    },
    approveException(exceptionId, data) {
        return makeCancellableAPIRequest(
          "POST",
          `/api/risk-register/${exceptionId}/approve`,
          {
            data
          }
        );
    },
    denyException(exceptionId, data) {
        return makeCancellableAPIRequest(
          "POST",
          `/api/risk-register/${exceptionId}/reject`,
          {
            data
          }
        );
    },
    copyException(exceptionId, clonedName) {
        return makeCancellableAPIRequest(
          "POST",
          `/api/risk-register/${exceptionId}/clone`,
          {
            data: {
              clonedName
            }
          }
        );
    },
    getOpenException(data) {
        return makeCancellableAPIRequest(
          "POST",
          `/api/risk-register/assignable`,
          {
            data
          }
        );
    },
    getComments(riskRegisterId){
      return makeCancellableAPIRequest(
        "GET",
        `api/risk-register/${riskRegisterId}/comments`
      )
    },
    postComments(riskRegisterId,{htmlText, markdownText, mentionedUserIds}){
      return makeCancellableAPIRequest(
        "POST",
        `api/risk-register/${riskRegisterId}/comments`,
        {
          data: { comment: htmlText, markdownText, mentionedUserIds }
      }
      )
    },
    extendException(riskRegisterId, data){
      return makeCancellableAPIRequest(
        "POST",
        `/api/risk-register/${riskRegisterId}/extend`,
        {
          data
        }
      )
    },
    getExceptionHistory(riskRegisterId){
      return makeCancellableAPIRequest(
        "GET",
        `api/risk-register/${riskRegisterId}/history`
      )
    },
    extendExceptionApproveByEndDate(data, riskRegisterId){
      return makeCancellableAPIRequest(
        "POST",
        `/api/risk-register/${riskRegisterId}/extend/approve-by-date`,
        {
          data
        }
      )
    },
    getRunbookAssignableExceptions(data){
      return makeCancellableAPIRequest(
        "POST",
        `/api/risk-register/assignable/runbook`,
        {
          data
        }
      );
    },
    updateCustomWorkflow(id, data) {
      return makeCancellableAPIRequest(
        "POST",
        `/api/risk-register/${id}/custom-workflow`,
        {
          data
        }
      );
    },
    requestNewException(data){ 
      const headers = {
        'X-AMC-User-Timezone': moment.tz.guess()
      }
      return makeCancellableAPIRequest(
        "POST",
        `/api/risk-register/basic`,
        {
          data,
          headers
        }
      );
    },
    getExceptionsFilters(data) {
        const modifiedData = exceptionModifyFilters(data);
        return makeCancellableAPIRequest(
            "POST",
            `/api/risk-register/stats`,
            {
                data: modifiedData
            }
        )
    },
  }

export default ExceptionAPI;

const modifyFilters = (params) => {
    const date = params?.filters?.["date"];
    //modify name param to searchText to fix paginated search select
    if(params.name){
      params.filters = {
        ...params.filters,
      searchText: params.name
      }
      delete params.name
    }
    if (date) {
      let _startDate, _endDate;
      if (date.length === 1) {
        [_startDate, _endDate] = getStartAndEndDateForQuickOption({
          label: date[0],
        });
      } else {
        [_startDate, _endDate] = date;
      }

      params.filters = {
        ...params.filters,
        startDate: moment(_startDate),
        endDate: moment(_endDate),
      };
      delete params.filters.date;
    }

    return params; 
};

export function exceptionModifyFilters (value) {
  const queryParams = cloneDeep(value);
  const { filters } = queryParams;
  if(filters.endDate) {
    filters.endDate = convertDateFilterValueToDate(undefined, filters.endDate);
  } 
  if(filters.startDate) {
    filters.startDate = convertDateFilterValueToDate(undefined, filters.startDate);
  }
  if(filters.submittedOn) {
    filters.submittedOn = convertDateFilterValueToDate(undefined, filters.submittedOn);
  }
  if(filters.approvedOn) {
    filters.approvedOn = convertDateFilterValueToDate(undefined, filters.approvedOn);
  }
  if(filters.approveByDate) {
    filters.approveByDate = convertDateFilterValueToDate(undefined, filters.approveByDate);
  }
  if (filters.name && Array.isArray(filters.name)){
    filters.name = filters.name[0];
  }
  return queryParams;
}
